import { type BillingInfoRes } from '@on3/api/src';
import { CreditCardBadge } from '@on3/ui-lib/components/CreditCard/Badge';
import clsx from 'clsx';

import styles from './CreditCard.module.scss';

export const CreditCard = ({
  className,
  billingInfo,
}: {
  className?: string;
  billingInfo?: Partial<BillingInfoRes>;
}) => (
  <div className={clsx(styles.block, className)}>
    <div className={styles.cardInfo}>
      {billingInfo?.expMonth && billingInfo?.expYear && (
        <dl className={styles.expiry}>
          <dt className="sr-only">Expires</dt>
          <dd>
            {String(billingInfo.expMonth).padStart(2, '0')}/
            {billingInfo.expYear}
          </dd>
        </dl>
      )}
      <dl className={styles.cardLastFour}>
        <dt className="sr-only">Card last four digits</dt>
        <dd>**** **** **** {billingInfo?.cardLastFour || '****'}</dd>
      </dl>
    </div>
    <div className={styles.cardType}>
      <CreditCardBadge type={billingInfo?.cardType} />
    </div>
  </div>
);
